import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 1.09c-2.56.17-5.06 1-7.2 2.41-1.7 1.12-3.17 2.6-4.3 4.3-.9 1.39-1.62 3.03-2.01 4.62-.99 4.05-.26 8.32 2.01 11.77 1.12 1.7 2.6 3.18 4.3 4.3 1.39.91 3.03 1.63 4.62 2.02 4.05.98 8.32.25 11.77-2.02 1.7-1.12 3.19-2.6 4.3-4.3.91-1.38 1.63-3.03 2.02-4.61.83-3.4.46-6.95-1.05-10.06-.77-1.58-1.67-2.85-2.9-4.08q-2.57-2.57-6.07-3.7C18.79 1.2 16.84.98 15 1.1m.02 2.29c-3.84.3-7.38 2.37-9.52 5.57q-1.66 2.46-2.07 5.51c-.08.63-.08 2.45 0 3.07.2 1.52.58 2.73 1.23 4.05.64 1.3 1.37 2.33 2.4 3.36s2.05 1.76 3.36 2.4c1.32.65 2.53 1.02 4.04 1.22.63.09 2.45.09 3.08 0 1.5-.2 2.72-.57 4.04-1.22 1.3-.64 2.34-1.37 3.36-2.4 1.03-1.03 1.76-2.06 2.4-3.36.53-1.07.85-2.01 1.07-3.13.19-.95.21-1.25.21-2.45s-.02-1.5-.2-2.45c-.23-1.12-.55-2.06-1.08-3.14-.64-1.3-1.37-2.33-2.4-3.35-1.02-1.03-2.06-1.77-3.36-2.4-1.3-.64-2.46-1-3.93-1.21-.35-.05-.67-.07-1.46-.07zm6.86 6.74c-.37.1-.2-.1-4.43 5.2-2.69 3.35-3.97 4.93-3.99 4.9-.47-.36-3.41-2.54-3.5-2.59-.41-.22-.96-.13-1.3.22-.08.08-.19.22-.24.32-.07.16-.08.22-.08.48 0 .36.05.52.26.74.15.17 4.4 3.37 4.63 3.48.14.08.2.09.47.09s.32-.01.48-.1c.1-.04.23-.13.29-.18.21-.22 8.7-10.85 8.77-11 .06-.12.07-.2.07-.47 0-.28-.01-.33-.09-.49-.25-.49-.82-.74-1.34-.6"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconCheckCircle;
